import { axiosClient } from '../../../../services/axiosInstance'
import { OrderForm } from '../../entity/orderForm'

export const clearMessages = async (orderFormId: string) => {
  const { data } = await axiosClient.post(
    `/api/checkout/orderForm/${orderFormId}/clearMessages`
  )

  return new OrderForm(data)
}
